<br />
<div style="text-align: center;">

    <h1>Historial Codeudor</h1>
</div>
<br />

<div class="container principal" id="tabla" style="background-color: white; padding-top: 10px; padding-bottom:50px;">
    <div class="container principal">
        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">
            <div class="row">
                <div class="col-lg-4">
                    <h2>Codeudor:</h2>
                </div>

                <div class="col-lg-8">
                    <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                    </h2>

                </div>

            </div>

        </div>
        <div *ngIf="rol != 'ROLE_AFILIADO'">

            <div class="row line">
                
                <div class="col-lg-2"> </div>

                <div class="col-lg-2">
                    <h2> Rut Codeudor </h2>
                </div>

                <div class="col-lg-3">

                    <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado" #rutAfiliado="ngModel"
                        class="form-control" type="text" required
                        placeholder="Ingrese el RUT del codeudor. Ej: 11111111-1"
                        pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>
                

                <div class="col-lg-1">

                    <button class="btn btn-primary" id="btnBuscarAfiliado" name="btnBuscarAfiliado"
                        (click)="buscaAfiliado(this.rutAfiliado.value)">

                        Buscar

                    </button>

                </div>
           
                <div class="col-lg-2" >
                
               
                </div>
            </div>
            <div class="row line">

                <div class="col-lg-2"> </div>

                <div class="col-lg-2"> </div>

                <div class="col-lg-3">
                    <mat-select class="form-control"  name="tipos" 
                    [(ngModel)]="buscador.tipos"  #tipos="ngModel" required>
                        <mat-option value="0">
                            PRODUCTOS
                        </mat-option>
                        <mat-option *ngFor="let tipo of this.tiposProd" value="{{tipo.id}}">
                            {{tipo.descripcion}}
                        </mat-option>
                    </mat-select>   
               

                </div>
            </div>
            <div class="row line">

                <div class="col-lg-4"> </div>
                <div class="col-lg-5">
                    <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                    </h2>
                </div>
            </div>
        </div>

    </div>
    <br />


    <div class="row line">
        <div class="col-lg-1"> </div>
        <div class="col-lg-3">
            <h2>Historial</h2>
        </div>

    </div>
    <div class="table-responsive">

        <table class="table" id="tablaPlan" name="tablaPlan">

            <thead style="background-color: #0f69b4;color:white;">               
                <tr>
                    <th>N°</th>
                    <th>Fecha Ingreso</th>                  
                    <th>Rut Solicitante</th>
                    <th>Nombre Solicitante</th>
                    <th>Tipo Producto</th>
                    <th>Categoría</th>
                    <th>Región</th>
                    <th>Proveedor</th>
                    <th>Monto Solicitado</th>
                    <th>Cantidad de Cuotas</th>
                    <th>Estado</th>
                    <th>Ver Archivo</th>
                  
                </tr>
            </thead>
            <tbody>
                <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'"
                    *ngFor="let postulacion of this.postulaciones | paginate: config; let i = index">
                    <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="openEditDialogValidar(postulacion.idPostulacion,  false,false,postulacion.tipoProducto)">{{postulacion.idPostulacion}}</a> </td>
                            <td style="text-align: center;">{{postulacion.fechaIngreso}}</td> 
                            <!--                          
                            <td style="text-align: center;" *ngIf="postulacion.idCarga != 0"> {{postulacion.rutCarga}} </td>
                            <td style="text-align: center;" *ngIf="postulacion.idCarga == 0"> <a style="cursor:pointer; text-decoration: underline" (click)="detalleBeneficiario(postulacion.rutUsuario)"> {{postulacion.rutUsuario}} </a> </td>
                            <td style="text-align: center;" *ngIf="postulacion.idCarga != 0">{{postulacion.nombreCarga}}</td>
                            <td style="text-align: center;" *ngIf="postulacion.idCarga == 0">{{postulacion.nombreUsuario}}</td>
                            --> 
                            <td style="text-align: center;" > <a style="cursor:pointer; text-decoration: underline" (click)="detalleBeneficiario(postulacion.rutUsuario)"> {{postulacion.rutUsuario}} </a> </td>
                            <td style="text-align: center;" >{{postulacion.nombreUsuario}}</td>

                            <td style="text-align: center;">{{postulacion.tipoProducto}}</td>
                            <td style="text-align: center;">{{postulacion.tipoConvenioString}}</td>
                            <td style="text-align: center;">{{postulacion.regionConvenio}}</td>
                            <td style="text-align: center;">{{postulacion.nombreCorto}} </td>
                            <td style="text-align: center;">{{postulacion.montoSolicitado}}</td>
                            <td style="text-align: center;">{{postulacion.cantidadCuota}}</td>

                            <td style="text-align: center;">{{postulacion.estado}}</td>
                            <td style="text-align: center;">
                                <p>
                                    <button class="mat-raised-button btn-info" (click)="onDescargarArchivosClick(postulacion.idPostulacion)">
                    
                                    <i class = "fa fa-download"> </i> Ver</button>
                                </p>
                            </td>                         
                            <td style="text-align: center;"></td>
                  
                </tr>
            </tbody>
        </table>
    

            <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente"
                (pageChange)="pageChanged($event,this.afiliado.rutAfiliado)" autoHide="true"> </pagination-controls>
    
    </div>
    <br>

    <br />





</div>





<br /><br /><br />